<!-- ============================================================== -->
<!-- Page wrapper  -->
<!-- ============================================================== -->
<div class="page-wrapper" [style.margin-top.px]="((layoutManager.mobileMode)?0:0)">
  <!-- ============================================================== -->
  <!-- Container fluid  -->
  <!-- ============================================================== -->
  <div class="container-fluid">
    <!-- ============================================================== -->
    <!-- Slider  -->
    <!-- ============================================================== -->
    <div class="bg-white">
      <section id="slider-sec" class="slider2">
        <div id="slider2" class="carousel bs-slider slide  control-round indicators-line"
             data-ride="carousel" data-pause="none" data-interval="6500">
          <ol class="carousel-indicators hide">
            <li data-target="#slider2" data-slide-to="0" class="active"></li>
            <li data-target="#slider2" data-slide-to="1"></li>
            <li data-target="#slider2" data-slide-to="2"></li>
          </ol>
          <!-- Wrapper For Slides -->
          <div class="carousel-inner" role="listbox">
            <div class="carousel-item active">
              <!-- Slide Background --><img src="../../../assets/images/server1.jpg" [style.width.%]="((layoutManager.mobileMode)?200:100)"
                                            alt="assetx" class="slide-image" />
              <!-- Slide Text Layer -->
              <div class="slide-text slide_style_left">
                <div class="col-md-9 col-lg-6">
                  <label class="label bg-white text-uppercase font-semibold" data-animation="animated fadeInDown">Benvenuto</label>
                  <h2 data-animation="animated zoomInRight" class="title text-white">AssetX Trading Systems</h2>
                </div>
                <div class="col-md-8 col-lg-5">
                  <p data-animation="animated fadeInLeft" class="m-t-40 m-b-40 hidden-sm-down text-white op-8">
                    Il meglio della tecnologia applicata ai mercati finanziari. Leggi la presentazione e conosci la nostra storia</p>
                </div>
                <div class="col-sm-12 btn-pad">
                  <a class="btn btn-info-gradiant btn-md btn-arrow" data-animation="animated fadeInLeft" data-toggle="collapse" href=""
                     (click)="redirectContacts()"> <span>Contattaci <i class="ti-arrow-right"></i></span> </a>
                  <a class="btn text-white" data-animation="animated fadeInRight" data-toggle="modal" href="#"
                    (click)="scroll(presentazioneabout)"><i class="icon-Play-Music text-white vm m-r-10"></i>
                    Guarda la presentazione</a>
                </div>
              </div>
            </div>
            <!-- End of Slide -->
            <!-- Second Slide -->
            <div class="carousel-item">
              <!-- Slide Background -->
              <img src="../../../assets/images/server2.jpg" alt="assetx" class="slide-image"
                   [style.width.%]="((layoutManager.mobileMode)?200:100)"/>
              <div class="bs-slider-overlay"></div>
              <!-- Slide Text Layer -->
              <div class="slide-text">
                <div class="col-md-9 col-lg-6">
                  <h2 data-animation="animated flipInX" class="title text-white">Da anni uniamo tecnologia e finanza</h2>
                </div>
                <div class="col-md-8 col-lg-5">
                  <p data-animation="animated lightSpeedIn" class="m-t-40 m-b-40 hidden-sm-down">Le nostre infrastrutture ci permettono di offrire un servizio altamente evoluto
                    è unico nel mondo degli investimenti in borsa.</p>
                </div>
                <div class="col-sm-12 btn-pad">
                  <a class="btn text-white" data-animation="animated fadeInRight" data-toggle="modal" href="#"
                     (click)="scroll(presentazioneabout)"><i class="icon-Play-Music text-white vm m-r-10"></i>
                    Guarda la presentazione</a>
                </div>
              </div>
            </div>
            <!-- Third Slide -->
            <div class="carousel-item" [style.margin-bottom.px]="(layoutManager.smallMode)?0:66">
              <!-- Slide Background -->
              <img src="../../../assets/images/milan.jpg" alt="assetx" class="slide-image"
                   [style.width.%]="((layoutManager.mobileMode)?200:100)"/>
              <div class="bs-slider-overlay"></div>
              <!-- Slide Text Layer -->
              <div class="slide-text">
                <div class="col-md-9 col-lg-6">
                  <h2 data-animation="animated flipInX" class="title text-white">Forniamo un supporto su misura per ogni cliente</h2>
                </div>
                <div class="col-md-8 col-lg-5">
                  <p data-animation="animated lightSpeedIn" class="m-t-40 m-b-40 hidden-sm-down">La nostra partnership con Group Traders ci permette di offrire un serivio
                    specialistico ad ogni nostro cliente.</p>
                </div>
                <div class="col-sm-12 btn-pad">
                  <a class="btn text-white" data-animation="animated fadeInRight" data-toggle="modal" href="#"
                     (click)="scroll(presentazioneabout)"><i class="icon-Play-Music text-white vm m-r-10"></i>
                    Guarda la presentazione</a>
                </div>
              </div>
            </div>
            <!-- Slider Control -->
            <div class="slider-control">
              <!-- Left Control -->
              <a class="left carousel-control-prev text-white font-14" href="#slider2" role="button" data-slide="prev"> <span class="ti-arrow-left" aria-hidden="true"></span> <b class="sr-only font-normal">Previous</b> </a>
              <!-- Right Control -->
              <a class="right carousel-control-next text-white font-14" href="#slider2" role="button" data-slide="next"> <span class="ti-arrow-right" aria-hidden="true"></span> <b class="sr-only font-normal">Next</b> </a>
            </div>
            <!-- End of Slider Control -->
          </div>
        </div>
        <!-- End Slider -->
        <p #presentazioneabout></p>

      </section>
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- Feature 12  -->
  <!-- ============================================================== -->
  <div class="spacer feature12">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="row">
            <div class="col-md-12 m-t-30">
              <h2 class="m-b-30 font-bold m-t-20">2017</h2>
              <h4 class="text-muted font-light">Nasce AssetX con l'obiettivo di portare innovazione, automazione e intelligenza
                artificiale nel mondo degli investimenti in borsa a breve termine, specialmente nel Forex-Trading.</h4>
            </div>
            <div class="col-md-12 m-t-30">
              <h5 class="font-medium">Primi progetti</h5>
              <p>Inizia il prototipo e la realizzazione di AssetCopier, il primo progetto ufficiale. AssetCopier è un sistema
                di automazione all'avanguardia con il fine di semplificare il processo di replica su conti "Client" la strategia operativa adottata dai
                trader esperti di Group Traders.</p>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="row wrap-feature-12">
            <div class="col-md-6">
              <div class="row" [style.margin-top.px]="(layoutManager.smallMode)?0:100">
                <div class="col-md-12"><img src="../../../assets/images/office.jpg" class="rounded img-shadow img-responsive" alt="assetx" /></div>
                <div class="col-md-12"><img src="../../../assets/images/world3.JPEG" class="rounded img-shadow img-responsive" alt="assetx" /></div>
              </div>
            </div>
            <div class="col-md-6 uneven-box">
              <div class="row">
                <div class="col-md-12" [style.margin-top.px]="(layoutManager.smallMode)?0:70"><img src="../../../assets/images/office2.jpg"
                                                                                                   class="rounded img-shadow img-responsive" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- End Feature 12  -->
  <!-- ============================================================== -->

  <!-- ============================================================== -->
  <!-- Call-to-Action 1  -->
  <!-- ============================================================== -->
  <div class="spacer bg-light c2a1" style="background-image:url(../../../assets/images/server2.jpg)">
    <div class="container">
      <!-- Row -->
      <div class="row justify-content-lg-end">
        <div class="col-md-7 text-right">
          <h2 class="title text-white font-medium">AssetCopier</h2>
          <p class="font-light text-white op-8">
            La principale caratteristica che rende AssetCopier unico nel mercato è la capacità di lavorare indipendentemente dal broker utilizzato,
            spesso questo aspetto si rivela essere d'ostacolo nel CopyTrading. Un'altra fondamentale caratteristica che distingue AssetCopier
            da ogni altro software utilizzato in precedenza è la decentralizzazione del suo utilizzo, ovvero è in grado di lavorare
            attraverso il web. Questa importante feature permette di poterlo installare nel proprio computer senza essere
            vincolati dal luogo in cui è installato il Sender.
          </p>

        </div>
      </div>
      <!-- Row -->
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- End Call-to-Action 1  -->
  <!-- ============================================================== -->

  <!-- ============================================================== -->
  <!-- Feature 12  -->
  <!-- ============================================================== -->
  <div class="spacer feature12">
    <div class="container">
      <div class="row">
        <div class="col-lg-6" style="margin-top: 40px">
          <div class="col-md-12 img-anim" data-aos="fade-up" data-aos-duration="2200" >
            <img src="../../../assets/images/milan2.jpg" alt="assetx" class="img-fluid m-t-20 img-rounded" />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="row">
            <div class="col-md-12 m-t-30">
              <h2 class="m-b-30 font-bold m-t-20">2018</h2>
              <h4 class="text-muted font-light">Il debutto dei Trading-Software AssetX, Expert Advisor dotati di
                intelligenza aritificiale applicati ai mercati finanziari.</h4>
            </div>
            <div class="col-md-12 m-t-30">
              <h5 class="font-medium">Circostanze</h5>
              <p>Assetcopier si rivela essere di rilevante successo e utilità
                nella condivisione di strategie operative, tanto che durante i suoi inizi AssetX ha sviluppato
                software capaci di "pensare" e agire autonomamente nei mercati finanziari, in grado di operare secondo
                propri algoritmi costantemente 24/h.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- End Feature 12  -->
  <!-- ============================================================== -->

  <!-- ============================================================== -->
  <!-- Feature 12  -->
  <!-- ============================================================== -->
  <div class="spacer feature12" style="margin-top: -100px">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="row">
            <div class="col-md-12 m-t-30">
              <h5 class="font-medium">Expert advisor</h5>
              <p>Un Expert Advisor (Congliere Esperto) è un software integrabile in MetaTrader, la pitattaforma per eccellenza
                  utilizzata nella compravendita di azioni e CFD. Per poter garantire ad un Expert Advisor un operatività 24/h 7/g è necessario
                  avere un server VPS (Virtual Private Server) su cui installarlo.</p>
            </div>
            <div class="col-md-12 m-t-30">
              <h5 class="font-medium">Progressi</h5>
              <p>La realizzazione di Trading Software progressivamente sempre più autosufficienti e sofisticati ha
                  preso sempre più piede nell'attività di AssetX.</p>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="col-md-12 img-anim" data-aos="fade-up" data-aos-duration="2200" >
            <img src="../../../assets/images/img2.png" alt="assetx" class="img-fluid m-t-20 img-rounded" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- End Feature 12  -->
  <!-- ============================================================== -->

  <!-- ============================================================== -->
  <!-- Call-to-Action 1  -->
  <!-- ============================================================== -->
  <div class="spacer bg-light c2a1" style="background-image:url(../../../assets/images/server1.jpg)" #assetcopierabout>
    <div class="container">
      <!-- Row -->
      <div class="row justify-content-lg-end">
        <div class="col-md-7 text-right">
          <h2 class="title text-white font-medium">AssetMax</h2>
          <p class="font-light text-white op-8">
            AssetMax è uno dei primi Trading Software di grande rilevanza realizzati da AssetX. In collaborazione con Group Traders
            negli ultimi anni è stato continuamente aggiornato e perfezionato, adattandolo e uniformandolo sempre di più alle mutanti
            condizioni che i mercati esigono. Attualmente è pienamente attivo ed utilizzato nei nostri sistemi.
          </p>
        </div>
      </div>
      <!-- Row -->
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- End Call-to-Action 1  -->
  <!-- ============================================================== -->

  <!-- ============================================================== -->
  <!-- Feature 12  -->
  <!-- ============================================================== -->
  <div class="spacer feature12">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="row">
            <div class="col-md-12 m-t-30">
              <h2 class="m-b-30 font-bold m-t-20">2019</h2>
              <h4 class="text-muted font-light">L'ultimo importante progetto realizzato da AssetX, con una grandissima ambizione
                  AssetX è riuscita a introdurre un livello di automazione mai visto in precedenza.</h4>
            </div>
            <div class="col-md-12 m-t-30">
              <h5 class="font-medium">AssetStore</h5>
              <p>Nel 2019 AssetX ha lanciato AssetStore, una piattaforma nata dall'esigenza di rendere accessibili a chiunque i software
                di Trading Automatizzato già in uso nell'operatività di AssetCopier.</p>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="col-md-12 img-anim" data-aos="fade-up" data-aos-duration="2200" >
            <img src="../../../assets/images/office2.jpg" alt="assetx" class="img-fluid m-t-20 img-rounded" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- End Feature 12  -->
  <!-- ============================================================== -->

  <!-- ============================================================== -->
  <!-- Feature 12  -->
  <!-- ============================================================== -->
  <div class="feature12">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="col-md-12 img-anim" data-aos="fade-up" data-aos-duration="2200" >
            <img src="../../../assets/images/market.jpg" alt="assetx" class="img-fluid m-t-20 img-rounded" />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="row">
            <div class="col-md-12 m-t-30">
              <h5 class="font-medium">Caratteristiche</h5>
              <p>AssetStore è una piattaforma in cui sfogliare, provare e acquistare i migliori Trading Software di
                AssetX, che confrontati per percentuale di Gain annuo si posizionano tra i migliori sul mercato. Non solo
                comunque è possibile acquistare i Trading Software di AssetX ma grazie ai programmi di partnership diamo
                spazio a chiunque abbia idee innovative per questo mercato, di poter accedere ai nostri servizi e ai nostri
                strumenti di Licenza.</p>
            </div>
            <div class="col-md-12 m-t-30">
              <h5 class="font-medium">Vantaggi</h5>
              <p>Attualmente è molto difficile gestire in autonomia la distribuzione e l'esecuzione di questo tipo di software:
                per la concessione delle licenze e per nell'installazione nei VPS. AssetStore offre numerose soluzioni
                volte a semplificare questi processi, tanto che è in grado di occuparsi della distribuzione e dell'esecuzione
                da parte del cliente in modo completamente automatizzato, questo grazie alle nostre infrastrutture server che
                ci permettono di vantare una tecnologia all'avanguardia ed estremamente performante.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- End Feature 12  -->
  <!-- ============================================================== -->
<br><br>
  <!-- ============================================================== -->
  <!-- Call-to-Action 1  -->
  <!-- ============================================================== -->
  <div class="spacer bg-light c2a1" style="background-image:url(../../../assets/images/milan.jpg)" #assetcopierabout>
    <div class="container">
      <!-- Row -->
      <div class="row justify-content-lg-start">
        <div class="col-md-7 text-left">
          <h2 class="title text-white font-medium">AssetX</h2>
          <p class="font-light text-white op-8">
            AssetX continua il suo sviluppo migliorando i suoi servizi costantemente, aggiornando i sistemi di
            trading portandoli sempre al passo con le condizioni imposte dai mercati in costante variazione, e
            portando sempre più automazione e innovazione in questo mercato. <br>Grazie per l'attenzione,<br>AssetX.
          </p>
        </div>
      </div>
      <!-- Row -->
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- End Call-to-Action 1  -->
  <!-- ============================================================== -->

  <!-- ============================================================== -->
  <!-- call to action -->
  <!-- ============================================================== -->
  <div class="mini-spacer bg-yellow text-white">
    <div class="container">
      <div class="d-flex">
        <div class="display-7 align-self-center">
          <h3 class="">AssetX realizza anche Expert Advisor su richiesta</h3>
          <h6 class="font-16">Per informazioni contattaci, ti risponderemo non appena possibile</h6>
        </div>
        <div class="ml-auto m-t-10 m-b-10">
          <button (click)="redirectContacts()" class="btn btn-info-gradiant btn-md">Contattaci</button>
        </div>
      </div>
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- call to action -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- Testimonial 6 -->
  <!-- ============================================================== -->
  <div class="testimonial6 spacer">
    <div class="container">
      <div class="row">
        <div class="col-lg-2 col-md-3" data-aos="fade-right">
          <div class="nav flex-column nav-pills testi6" id="v-pills-tab" role="tablist">
            <a class="nav-link" data-toggle="pill" href="#t6-1" role="tab" aria-controls="t6-1" aria-expanded="true">
              <img src="../../../assets/images/user.png" alt="assetx" class="circle" />
            </a>
            <a class="nav-link active" data-toggle="pill" href="#t6-2" role="tab" aria-controls="t6-2" aria-expanded="true">
              <img src="../../../assets/images/user.png" alt="assetx" class="circle" />
            </a>
            <a class="nav-link" data-toggle="pill" href="#t6-3" role="tab" aria-controls="t6-3" aria-expanded="true">
              <img src="../../../assets/images/user.png" alt="assetx" class="circle" />
            </a>
            <a class="nav-link" data-toggle="pill" href="#t6-4" role="tab" aria-controls="t6-4" aria-expanded="true">
              <img src="../../../assets/images/user.png" alt="assetx" class="circle" />
            </a>
            <a class="nav-link" data-toggle="pill" href="#t6-5" role="tab" aria-controls="t6-5" aria-expanded="true">
              <img src="../../../assets/images/user.png" alt="assetx" class="circle" />
            </a>
            <a class="nav-link" data-toggle="pill" href="#t6-6" role="tab" aria-controls="t6-6" aria-expanded="true">
              <img src="../../../assets/images/user.png" alt="assetx" class="circle" />
            </a>
          </div>
        </div>
        <div class="col-lg-9 col-md-8 ml-auto align-self-center" data-aos="fade-up">
          <div class="tab-content" id="v-pills-tabContent">
            <div class="tab-pane fade" id="t6-1" role="tabpanel">
              <h2 class="font-bold">Cosa ne pensano i nostri clienti</h2>
              <h6 class="subtitle m-t-40">
                Ho provato altre aziende e sono stata fregata, con Group Traders sono contentissima
                perché sono onesti, corretti, disponibili e ti danno i giusti consigli.<br>
                Devo solo ringraziare!</h6>
              <div class="d-flex m-t-40">
                <div>
                  <h5 class="m-b-0 text-uppercase">Viola</h5>
                  <h6 class="subtitle">Milano</h6></div>
                <button class="btn btn-circle btn-info btn-md ml-auto"><i class="fa fa-quote-left"></i></button>
              </div>
            </div>
            <div class="tab-pane fade show active" id="t6-2" role="tabpanel">
              <h2 class="font-bold">Cosa ne pensano i nostri clienti</h2>
              <h6 class="subtitle m-t-40">Mi sono abbonato ad inizio 2020 prima a AssetRsi implementando ad Aprile  AssetMax,
                risultati sorprendenti con rese mensili considerevoli. Ma il valore aggiunto sono le persone che assistono e
                consigliano prontamente di modificare le configurazioni per massimizzare il profitto in ogni condizione di mercato.</h6>
              <div class="d-flex m-t-40">
                <div>
                  <h5 class="m-b-0 text-uppercase">Stefano</h5>
                  <h6 class="subtitle">Arese (MI)</h6></div>
                <button class="btn btn-circle btn-info btn-md ml-auto"><i class="fa fa-quote-left"></i></button>
              </div>
            </div>
            <div class="tab-pane fade" id="t6-3" role="tabpanel">
              <h2 class="font-bold">Cosa ne pensano i nostri clienti</h2>
              <h6 class="subtitle m-t-40">
                Che dire di questo fantastico sistema robotizzato programmato e gestito da persone valide competenti, averlo conosciuto prima...
                comunque non è mai troppo tardi, io lo consiglio a tutti indipendentemente dalla conoscenza del trading.</h6>
              <div class="d-flex m-t-40">
                <div>
                  <h5 class="m-b-0 text-uppercase">Andrea</h5>
                  <h6 class="subtitle">Lama Mocogno</h6></div>
                <button class="btn btn-circle btn-info btn-md ml-auto"><i class="fa fa-quote-left"></i></button>
              </div>
            </div>
            <div class="tab-pane fade show" id="t6-4" role="tabpanel">
              <h2 class="font-bold">Cosa ne pensano i nostri clienti</h2>
              <h6 class="subtitle m-t-40">Mi sono avvicinato al Trading Automatico con molto scetticismo... e con grande sorpresa ho
                raddoppiato il mio capitale in 6 mesi!!! Semplicemente fantastico!</h6>
              <div class="d-flex m-t-40">
                <div>
                  <h5 class="m-b-0 text-uppercase">Carlo</h5>
                  <h6 class="subtitle">Matera</h6></div>
                <button class="btn btn-circle btn-info btn-md ml-auto"><i class="fa fa-quote-left"></i></button>
              </div>
            </div>
            <div class="tab-pane fade show" id="t6-5" role="tabpanel">
              <h2 class="font-bold">Cosa ne pensano i nostri clienti</h2>
              <h6 class="subtitle m-t-40">
                Il servizio dell'Expert Advisor è semplice da usare e i risultati sono sempre di ottima qualità. È la migliore azienda con la quale io abbia mai operato senza pensieri.
              </h6>
              <div class="d-flex m-t-40">
                <div>
                  <h5 class="m-b-0 text-uppercase">Marcella</h5>
                  <h6 class="subtitle">Bolzano</h6></div>
                <button class="btn btn-circle btn-info btn-md ml-auto"><i class="fa fa-quote-left"></i></button>
              </div>
            </div>
            <div class="tab-pane fade show" id="t6-6" role="tabpanel">
              <h2 class="font-bold">Cosa ne pensano i nostri clienti</h2>
              <h6 class="subtitle m-t-40">
                La prima volta che mi sono rivolta a Group Traders ne sono rimasta stregata,
                specie per gli straordinari risultati e per la semplicità del servizio. Vedo crescere il mio capitale e sono contentissima!!
              </h6>
              <div class="d-flex m-t-40">
                <div>
                  <h5 class="m-b-0 text-uppercase">Anna</h5>
                  <h6 class="subtitle">Lamezia Terme</h6></div>
                <button class="btn btn-circle btn-info btn-md ml-auto"><i class="fa fa-quote-left"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- End Testimonial 6 -->
  <!-- ============================================================== -->

  <!-- End Container fluid  -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- Back to top -->
  <!-- ============================================================== -->
  <a class="bt-top btn btn-circle btn-lg btn-info" href="#top"><i class="ti-arrow-up"></i></a>
</div>
